import React, { useEffect } from 'react';

import { useUserMatchScoresState, useUserMatchScoresActions } from './UserMatchScoresContext';
import UserMatchScoresLoader from './UserMatchScoresLoader';
import UserMatchScoresTable from './UserMatchScoresTable';
import UserMatchScoresPageController from './UserMatchScoresPageController';
import CreateJobProspectModal from './CreateJobProspectModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Sidebar from '../../Shared/UI/Sidebar/components/Sidebar';
import SidebarItem from '../../Shared/UI/Sidebar/components/SidebarItem';

import styles from './UserMatchScores.layout.module.scss';

const UserMatchScoresContent = () => {
  const state = useUserMatchScoresState();

  if (state?.loading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <PageTitle text={`Match Scores (${state?.totalCount || 0} total)`} />
      <UserMatchScoresTable />
      {state?.numberOfPages > 1 && <UserMatchScoresPageController />}
    </>
  );
};

const UserMatchScores = ({ userId }) => {
  const { initializeState } = useUserMatchScoresActions();

  useEffect(() => {
    if (userId) {
      initializeState(userId);
    }
  }, [userId]);

  const basePath = '/job_prospects_stats/user_pipeline_debug';
  const scoresPath = `/job_prospects_stats/user_match_scores?user_id=${userId}`;

  return (
    <>
      <UserMatchScoresLoader />
      <CreateJobProspectModal />
      <section className={styles.container}>
        <div className={styles.body}>
          <Sidebar aria-label="User pipeline navigation">
            <SidebarItem href="/job_prospects_stats">← Stats Overview</SidebarItem>
            <SidebarItem href={`${basePath}?user_id=${userId}`}>Overview</SidebarItem>
            <SidebarItem href={scoresPath} active>Match Scores</SidebarItem>
          </Sidebar>
          <div className={styles.content}>
            <UserMatchScoresContent />
          </div>
        </div>
      </section>
    </>
  );
};

export default UserMatchScores;
